var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        [
          _c(
            "b-card-title",
            { staticClass: "mb-75" },
            [
              _vm._v(" " + _vm._s(_vm.activity.name) + " "),
              _vm.activity.meta.isUpdating
                ? _c("b-spinner", {
                    staticClass: "float-right",
                    attrs: { small: "", variant: "primary" }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "border rounded mb-3 px-4 py-3" },
            [
              _c("b-card-text", {
                domProps: {
                  innerHTML: _vm._f("markdown")(_vm.activity.description)
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "clearfix" },
            [
              _c("ActivityAliveBadge", {
                staticClass: "float-right",
                attrs: {
                  "show-date": "",
                  "expired-at": _vm.activity.expiredAt,
                  "created-at": _vm.activity.createdAt
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "text-right mt-2 font-weight-bold" }, [
            _vm._v(" " + _vm._s(_vm.activity.targetUserName) + " ")
          ])
        ],
        1
      ),
      _c("ActivityComments", { attrs: { "activity-id": _vm.activity.id } }),
      _c("ActivityTimeline", { attrs: { "activity-id": _vm.activity.id } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }